module.exports = __webpack_public_path__ + "img/glucose_meter_whtie.f943d77f.svg";